import { arrayContainsValues } from '@shared/core/types/common';

const appleMerchantCapability: ApplePayJS.ApplePayMerchantCapability[] = [
    'supports3DS', 'supportsEMV', 'supportsCredit', 'supportsDebit'
];

export const appleMerchantCapabilityType = arrayContainsValues(...appleMerchantCapability);
